module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "home-view"
  }, [_c('section', {
    staticClass: "cover hero-cover"
  }, [_c('div', {
    staticClass: "cover-bg"
  }), _vm._v(" "), _c('video', {
    staticClass: "hero-video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "playsinline": "",
      "poster": _vm.assets.transparent,
      "preload": "metadata"
    },
    domProps: {
      "muted": _vm.isMobileDevice()
    }
  }, [_c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "src": _vm.$t('pages.home.hero-cover.video.webm.md'),
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "src": _vm.$t('pages.home.hero-cover.video.mp4.md'),
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.$t('pages.home.hero-cover.video.webm.xs'),
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.$t('pages.home.hero-cover.video.mp4.xs'),
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "scroll-down-indicator",
    attrs: {
      "src": require("@/assets/images/covers/hero-video-scroll-down.svg")
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "cover ruyi-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.ruyi.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/plus-circle-o.svg")
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cover technology-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.technology.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/plus-circle-o.svg")
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cover fashion-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.fashion.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/plus-circle-o.svg")
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cover sustainability-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.sustainability.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/plus-circle-o.svg")
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687faf80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Home.vue
// module id = 628
// module chunks = 1